import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import LoginScreen from "../containers/auth/screens/LoginScreen";
import LogOut from "../containers/auth/LogOut";
import PrivateRoute from "../containers/auth/PrivateRoute";
import DashboardScreen from "../containers/dashboard/screens/DashboardScreen";
import ConfirmacionScreen from "../containers/dashboard/screens/ConfirmacionScreen";
import AutorizacionScreen from "../containers/autorizacion/screens/AutorizacionScreen";
import DetalleAutorizacionScreen from "../containers/autorizacion/screens/DetalleAutorizacionScreen";
import VoucherScreen from "../containers/autorizacion/screens/VoucherScreen";
import VoucherGmmScreen from "../containers/autorizacion/screens/VoucherGmmScreen";
import BusquedaAutorizacionScreen from "../containers/autorizacion/screens/BusquedaAutorizacionScreen";
import MedicamentoScreen from "../containers/medicamento/screens/MedicamentoScreen";
import ConfirmarPrecertificacionScreen from "../containers/precertificacion/screens/ConfirmarPrecertificacionScreen";
import CancelarPrecertificacionScreen from "../containers/precertificacion/screens/CancelarPrecertificacionScreen";
import CierreCuentaClinicaScreen from "../containers/hospitalizacion/screens/CierreCuentaClinicaScreen";
import BusquedaCierresCuentasScreen from "../containers/hospitalizacion/screens/BusquedaCierresCuentasScreen";
import PacientesIngresadosScreen from "../containers/hospitalizacion/screens/PacientesIngresadosScreen";
import DetallesPacienteIngresadoScreen from "../containers/hospitalizacion/screens/DetallesPacienteIngresadoScreen";
import CrearValidacionHojaQXScreen from "../containers/hospitalizacion/screens/CrearValidacionHojaQXScreen";
import ValidacionesHojaQXScreen from "../containers/hospitalizacion/screens/ValidacionesHojaQXScreen";
import { PSS_TYPE } from "../utils/Constant";

const HOSPITALIZACION_RESTRICTED_PSS_TYPES = [PSS_TYPE.MEDICO];

export default function Routes() {
  const routes = [
    { path: "/login", component: LoginScreen, exact: true, private: false },
    { path: "/logout", component: LogOut, private: false },
    { path: "/dashboard", component: DashboardScreen, private: true },
    { path: "/confirmacion", component: ConfirmacionScreen, private: true },
    { path: "/autorizacion", component: AutorizacionScreen, private: true },
    { path: "/medicamentos", component: MedicamentoScreen, private: true },
    {
      path: "/detalle-autorizacion/:numeroAutorizacion/:ano",
      component: DetalleAutorizacionScreen,
      private: true,
    },
    {
      path: "/detalle-autorizacion/:numeroAutorizacion",
      component: DetalleAutorizacionScreen,
      private: true,
    },
    {
      path: "/detalle-autorizacion",
      component: DetalleAutorizacionScreen,
      exact: true,
      private: true,
    },
    {
      path: "/detalle-autorizacion/:numeroAutorizacion/:ano",
      component: DetalleAutorizacionScreen,
      private: true,
    },
    {
      path: "/detalle-autorizacion/:numeroAutorizacion",
      component: DetalleAutorizacionScreen,
      private: true,
    },
    {
      path: "/detalle-autorizacion",
      component: DetalleAutorizacionScreen,
      exact: true,
      private: true,
    },
    { path: "/voucher", component: VoucherScreen, private: true },
    { path: "/voucher-gmm", component: VoucherGmmScreen, private: true },
    {
      path: "/busqueda-autorizacion",
      component: BusquedaAutorizacionScreen,
      private: true,
    },
    {
      path: "/confirmar-precertificacion",
      component: ConfirmarPrecertificacionScreen,
      private: true,
    },
    {
      path: "/cancelar-precertificacion",
      component: CancelarPrecertificacionScreen,
      private: true,
    },
    {
      path: "/cierre-cuenta-clinica",
      component: CierreCuentaClinicaScreen,
      private: true,
    },
    {
      path: "/busqueda-avanzada-egresos",
      component: BusquedaCierresCuentasScreen,
      private: true,
    },
    {
      path: "/pacientes-ingresados",
      component: PacientesIngresadosScreen,
      private: true,
      restrictedPssTypes: HOSPITALIZACION_RESTRICTED_PSS_TYPES,
    },
    {
      path: "/paciente-ingresado/:numeroIngreso",
      component: DetallesPacienteIngresadoScreen,
      private: true,
      restrictedPssTypes: HOSPITALIZACION_RESTRICTED_PSS_TYPES,
    },
    {
      path: "/validar-hoja-QX/:numeroIngreso",
      component: CrearValidacionHojaQXScreen,
       private: true, restrictedPssTypes: HOSPITALIZACION_RESTRICTED_PSS_TYPES
    },
    {
      path: "/validaciones-hoja-qx",
      component: ValidacionesHojaQXScreen,
      private: true,
      restrictedPssTypes: HOSPITALIZACION_RESTRICTED_PSS_TYPES,
    },
  ];

  const renderRoute = (route) => {
    if (route.private) {
      return (
        <PrivateRoute
          key={route.path}
          path={route.path}
          component={route.component}
          exact={route.exact}
          restrictedPssTypes={route.restrictedPssTypes}
        />
      );
    }

    return (
      <Route key={route.path} path={route.path} exact={route.exact}>
        <route.component />
      </Route>
    );
  };

  return (
    <Switch>
      {routes.map(renderRoute)}
      <Route path="/">
        <Redirect to="/login" />
      </Route>
    </Switch>
  );
}
